module.exports = __webpack_public_path__ + "img/ebike-1x.de62f02b.png";